import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export type CompanyFeatureFlags = {
    demoLicenseWithCustomEmailPattern: boolean;
    isAllowedToDownloadOnlineExchangeFile: boolean;
};


export class CompanyFeaturesQuery extends Query<CompanyFeatureFlags> { }

export class CompanyFeaturesQueryHandlerBase implements QueryHandler<CompanyFeaturesQuery, CompanyFeatureFlags> {
    private static Url = TaggedUrl.join('myCompany/features', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(): Promise<CompanyFeatureFlags> {
        const { data } = await this.http.get<CompanyFeatureFlags>(CompanyFeaturesQueryHandlerBase.Url);
        return {
            demoLicenseWithCustomEmailPattern: data.demoLicenseWithCustomEmailPattern,
            isAllowedToDownloadOnlineExchangeFile: data.isAllowedToDownloadOnlineExchangeFile
        };
    }
}
